import Header from '@/components/Header/Header.vue'

export default {
  Name: 'Category',
  components: {
    'v-header': Header
  }
}
